const state = {
  menuVisible: false,
  loading: false
};

const actions = {
  toggleMenu({ commit }: any) {
    commit('toggle');
  },
  setLoading({ commit }: any, loading: boolean) {
    commit('setLoading', loading);
  }
};

const mutations = {
  toggle(state: any) {
    state.menuVisible = !state.menuVisible;
  },
  setLoading(state: any, loading: boolean) {
    state.loading = loading;
  }
};

export const application = {
  namespaced: true,
  state,
  actions,
  mutations
};
